<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="warehouseLocation.pkId ? '编辑' : '新建'"
      width="600px"
      top="10vh"
      @close="$reset('form')">
    <el-form ref="form" :rules="ruleValidate" :model="warehouseLocation" label-width="80px">
      <el-form-item label="仓位编号" prop="warehouseLocationNo" :disabled="warehouseLocation.pkId > 0">
        <el-input v-model="warehouseLocation.warehouseLocationNo" :disabled="warehouseLocation.pkId > 0"/>
      </el-form-item>
      <el-form-item label="仓位名称" prop="warehouseLocationName">
        <el-input v-model="warehouseLocation.warehouseLocationName" placeholder="请输入仓位名称"/>
      </el-form-item>
      <el-form-item label="所属库区" prop="warehouseAreaName">
        <el-input v-model="warehouseLocation.warehouseAreaName" placeholder="请选择所属库区" readonly>
          <el-button slot="append" icon="el-icon-search" @click="$refs.selectWarehouseArea.open()"/>
        </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="submitHandle">确定</el-button>
      <warehouse-area-select ref="selectWarehouseArea" @select="selectWarehouseArea"/>
    </span>
  </el-dialog>
</template>

<script>
  import WarehouseAreaSelect from "@/views/information/WarehouseArea/WarehouseAreaSelect";

  export default {
    components: {
      WarehouseAreaSelect,
    },
    data() {
      return {
        dialogVisible: false,
        warehouseLocation: {
          pkId: 0,
          warehouseLocationNo: "",
          warehouseLocationName: "",
          warehouseAreaId: 0,
          warehouseNo: "",
          warehouseName: "",
          warehouseAreaNo: "",
          warehouseAreaName: "",
        },
        ruleValidate: {
          warehouseLocationName: [{ required: true, message: "请输入名称", trigger: "blur" }],
          warehouseAreaName: [{ required: true, message: "请选择库区", trigger: "blur" }],
        },
        submitLoading: false,
      };
    },

    methods: {
      open(mark, row) {
        this.dialogVisible = true;
        if (row) {
          this.warehouseLocation = Object.assign(this.warehouseLocation, row);
          this.warehouseLocation.warehouseNo = row.warehouseNo;
          this.warehouseLocation.warehouseName = row.warehouseName;
          this.warehouseLocation.warehouseAreaNo = row.warehouseAreaNo;
          this.warehouseLocation.warehouseAreaName = row.warehouseAreaName;
          this.warehouseLocation.warehouseAreaId = row.warehouseAreaId;
          this.warehouseLocation.warehouseLocationNo = row.warehouseLocationNo;
          this.warehouseLocation.warehouseLocationName = row.warehouseLocationName;
          this.warehouseLocation.pkId = row.pkId;
        }
      },
      // 库区选择
      selectWarehouseArea(row) {
        console.log(row);
        this.warehouseLocation.warehouseAreaName = row.warehouseAreaName;
        this.warehouseLocation.warehouseAreaNo = row.warehouseAreaNo;
        this.warehouseLocation.warehouseAreaId = row.pkId;
      },
      submitHandle() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .save("basic", "warehouseLocations", this.warehouseLocation)
              .then((res) => {
                if (res.success) {
                  this.$emit("save-success");
                  if (!this.warehouseLocation.pkId) {
                    this.$message.success("添加成功");
                  } else {
                    this.$message.success("编辑成功");
                  }
                  this.dialogVisible = false;
                }
                this.submitLoading = false;
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>
